// @generated by gen_extension_constants.py. Do not modify!
/* eslint-disable */
export const ADOBECS_EXTS = [
    ".ai",
    ".eps"
];
export const ARCHIVE_EXTS = [
    ".7z",
    ".bz",
    ".bz2",
    ".cpio",
    ".gz",
    ".iso",
    ".lha",
    ".lz",
    ".lzh",
    ".lzma",
    ".rar",
    ".tar",
    ".taz",
    ".tbz",
    ".tbz2",
    ".tgz",
    ".tlz",
    ".txz",
    ".tz",
    ".xar",
    ".xz",
    ".z",
    ".zip"
];
export const AUDIO_EXTS = [
    ".aac",
    ".aif",
    ".aiff",
    ".flac",
    ".m4a",
    ".m4r",
    ".mp3",
    ".oga",
    ".ogg",
    ".wav",
    ".wma"
];
export const AUTOCAD_EXTS = [
    ".dwg"
];
export const CLOUD_DOC_EXTS = [
    ".binder",
    ".form",
    ".gdoc",
    ".gsheet",
    ".gslides",
    ".paper",
    ".papert",
    ".result",
    ".web"
];
export const CODE_EXTS = [
    ".abap",
    ".ada",
    ".ahk",
    ".as",
    ".as3",
    ".ascx",
    ".asm",
    ".aspx",
    ".awk",
    ".bash",
    ".bat",
    ".bib",
    ".build",
    ".c",
    ".cc",
    ".cfc",
    ".cfm",
    ".cfml",
    ".cl",
    ".clj",
    ".cls",
    ".cmake",
    ".cmd",
    ".coffee",
    ".cpp",
    ".cpy",
    ".cs",
    ".css",
    ".cxx",
    ".d",
    ".di",
    ".diff",
    ".dtd",
    ".el",
    ".erb",
    ".erl",
    ".f",
    ".fs",
    ".fsi",
    ".gemfile",
    ".gemspec",
    ".go",
    ".groovy",
    ".gry",
    ".h",
    ".haml",
    ".handlebars",
    ".hbs",
    ".hh",
    ".hpp",
    ".hrl",
    ".hs",
    ".hxx",
    ".idl",
    ".inc",
    ".inf",
    ".ini",
    ".jade",
    ".java",
    ".js",
    ".json",
    ".jsp",
    ".jsx",
    ".less",
    ".lhs",
    ".lisp",
    ".lst",
    ".lua",
    ".m",
    ".make",
    ".ml",
    ".mli",
    ".mll",
    ".mly",
    ".mm",
    ".out",
    ".p",
    ".pas",
    ".patch",
    ".php",
    ".phtml",
    ".pl",
    ".plist",
    ".pm",
    ".pp",
    ".properties",
    ".py",
    ".pyw",
    ".r",
    ".rake",
    ".rb",
    ".rbx",
    ".reg",
    ".rest",
    ".rhtml",
    ".rprofile",
    ".rs",
    ".rss",
    ".rst",
    ".s",
    ".sass",
    ".scala",
    ".scm",
    ".sconscript",
    ".sconstruct",
    ".script",
    ".scss",
    ".sh",
    ".sml",
    ".sql",
    ".swift",
    ".tex",
    ".tmpl",
    ".tpl",
    ".tsx",
    ".vb",
    ".vi",
    ".vim",
    ".wsdl",
    ".xhtml",
    ".xml",
    ".xsd",
    ".xsl",
    ".xslt",
    ".yaml",
    ".yml",
    ".zsh"
];
export const CREATIVE_DOC_EXTS = [
    ".psd",
    ".svg",
    ".svgz"
];
export const DOCUMENT_EXTS = [
    ".ai",
    ".csv",
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".dwg",
    ".eps",
    ".hwp",
    ".key",
    ".keynote",
    ".ods",
    ".pdf",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".xlt",
    ".xltx"
];
export const DOC_PDF_PREVIEW_EXTS = [
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".odp",
    ".odt",
    ".pdf",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf",
    ".wpd"
];
export const DOC_THUMBNAIL_EXTS = [
    ".csv",
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".ods",
    ".pdf",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".xlt",
    ".xltx"
];
export const DOC_THUMBNAIL_HTML_EXTS = [
    ".csv",
    ".ods",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".xlt",
    ".xltx"
];
export const DOC_THUMBNAIL_PDF_EXTS = [
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".pdf",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf"
];
export const EPUB_EXTS = [
    ".azw4",
    ".djvu",
    ".epub",
    ".mobi"
];
export const FONT_EXTS = [
    ".otf",
    ".ttf"
];
export const FORMS_CLOUD_DOC_EXTS = [
    ".form",
    ".result"
];
export const GALLERY_EXTS = [
    ".3fr",
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".arw",
    ".asf",
    ".avi",
    ".avif",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".dv",
    ".erf",
    ".flv",
    ".gif",
    ".heic",
    ".j2c",
    ".j2k",
    ".jp2",
    ".jpc",
    ".jpeg",
    ".jpf",
    ".jpg",
    ".jpg2",
    ".jpm",
    ".jpx",
    ".kdc",
    ".m2t",
    ".m2ts",
    ".m4v",
    ".mef",
    ".mkv",
    ".mos",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mrw",
    ".mts",
    ".mxf",
    ".nef",
    ".nrw",
    ".oggtheora",
    ".ogv",
    ".orf",
    ".pef",
    ".png",
    ".ppm",
    ".r3d",
    ".raf",
    ".rm",
    ".rw2",
    ".rwl",
    ".sr2",
    ".tga",
    ".tif",
    ".tiff",
    ".ts",
    ".vob",
    ".wbmp",
    ".web",
    ".webm",
    ".webp",
    ".wmv",
    ".x3f"
];
export const GALLERY_IMAGE_EXTS = [
    ".3fr",
    ".arw",
    ".avif",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".erf",
    ".gif",
    ".heic",
    ".j2c",
    ".j2k",
    ".jp2",
    ".jpc",
    ".jpeg",
    ".jpf",
    ".jpg",
    ".jpg2",
    ".jpm",
    ".jpx",
    ".kdc",
    ".mef",
    ".mos",
    ".mrw",
    ".nef",
    ".nrw",
    ".orf",
    ".pef",
    ".png",
    ".ppm",
    ".r3d",
    ".raf",
    ".rw2",
    ".rwl",
    ".sr2",
    ".tga",
    ".tif",
    ".tiff",
    ".wbmp",
    ".web",
    ".webp",
    ".x3f"
];
export const GENERATED_PREVIEW_EXTS = [
    ".ai",
    ".csv",
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".dwg",
    ".eps",
    ".gdoc",
    ".gsheet",
    ".gslides",
    ".odp",
    ".ods",
    ".odt",
    ".paper",
    ".papert",
    ".pdf",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf",
    ".wpd",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".xlt",
    ".xltx"
];
export const GOOGLE_CLOUD_DOC_EXTS = [
    ".gdoc",
    ".gsheet",
    ".gslides"
];
export const GOOGLE_CLOUD_DOC_GSHEET_EXTS = [
    ".gsheet"
];
export const GOOGLE_CLOUD_DOC_NON_GSHEET_EXTS = [
    ".gdoc",
    ".gslides"
];
export const HANCOM_DOC_EXTS = [
    ".hwp"
];
export const HTMLIFIED_PREVIEW_EXTS = [
    ".abap",
    ".ada",
    ".adp",
    ".ahk",
    ".as",
    ".as3",
    ".asc",
    ".ascx",
    ".asm",
    ".asp",
    ".aspx",
    ".awk",
    ".bash",
    ".bash_login",
    ".bash_logout",
    ".bash_profile",
    ".bashrc",
    ".bat",
    ".bib",
    ".bsh",
    ".build",
    ".builder",
    ".c",
    ".c++",
    ".capfile",
    ".cc",
    ".cfc",
    ".cfm",
    ".cfml",
    ".cl",
    ".clj",
    ".cls",
    ".cmake",
    ".cmd",
    ".coffee",
    ".cpp",
    ".cpt",
    ".cpy",
    ".cs",
    ".cshtml",
    ".cson",
    ".csproj",
    ".css",
    ".csv",
    ".ctp",
    ".cxx",
    ".d",
    ".ddl",
    ".di",
    ".dif",
    ".diff",
    ".disco",
    ".dml",
    ".dtd",
    ".dtml",
    ".el",
    ".emakefile",
    ".erb",
    ".erl",
    ".f",
    ".f90",
    ".f95",
    ".fs",
    ".fsi",
    ".fsscript",
    ".fsx",
    ".gemfile",
    ".gemspec",
    ".gitconfig",
    ".go",
    ".groovy",
    ".gry",
    ".gvy",
    ".h",
    ".h++",
    ".haml",
    ".handlebars",
    ".hbs",
    ".hcp",
    ".hh",
    ".hpp",
    ".hrl",
    ".hs",
    ".htc",
    ".hxx",
    ".idl",
    ".iim",
    ".inc",
    ".inf",
    ".ini",
    ".inl",
    ".ipp",
    ".irbrc",
    ".jade",
    ".jav",
    ".java",
    ".js",
    ".json",
    ".jsp",
    ".jsx",
    ".l",
    ".less",
    ".lhs",
    ".lisp",
    ".log",
    ".lst",
    ".ltx",
    ".lua",
    ".m",
    ".make",
    ".markdn",
    ".markdown",
    ".md",
    ".mdown",
    ".mkdn",
    ".ml",
    ".mli",
    ".mll",
    ".mly",
    ".mm",
    ".mud",
    ".nfo",
    ".opml",
    ".org",
    ".osascript",
    ".out",
    ".p",
    ".pas",
    ".patch",
    ".php",
    ".php2",
    ".php3",
    ".php4",
    ".php5",
    ".phtml",
    ".pl",
    ".plist",
    ".pm",
    ".pod",
    ".pp",
    ".profile",
    ".properties",
    ".ps1",
    ".psd1",
    ".psm1",
    ".pt",
    ".py",
    ".pyw",
    ".r",
    ".rake",
    ".rb",
    ".rbx",
    ".rc",
    ".re",
    ".readme",
    ".reg",
    ".rest",
    ".resw",
    ".resx",
    ".rhtml",
    ".rjs",
    ".rprofile",
    ".rpy",
    ".rs",
    ".rss",
    ".rst",
    ".rxml",
    ".s",
    ".sass",
    ".scala",
    ".scm",
    ".sconscript",
    ".sconstruct",
    ".script",
    ".scss",
    ".sgml",
    ".sh",
    ".shtml",
    ".sml",
    ".sql",
    ".sty",
    ".swift",
    ".tcl",
    ".tex",
    ".text",
    ".textile",
    ".tld",
    ".tli",
    ".tmpl",
    ".tpl",
    ".tsx",
    ".txt",
    ".vb",
    ".vi",
    ".vim",
    ".wsdl",
    ".xhtml",
    ".xml",
    ".xoml",
    ".xsd",
    ".xsl",
    ".xslt",
    ".yaml",
    ".yaws",
    ".yml",
    ".zsh"
];
export const IMAGE_EXIF_EXTS = [
    ".3fr",
    ".arw",
    ".bmp",
    ".cr2",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".erf",
    ".gif",
    ".heic",
    ".jpeg",
    ".jpg",
    ".kdc",
    ".mef",
    ".mos",
    ".mrw",
    ".nef",
    ".nrw",
    ".orf",
    ".pef",
    ".png",
    ".ppm",
    ".r3d",
    ".raf",
    ".rw2",
    ".rwl",
    ".sr2",
    ".tif",
    ".tiff",
    ".webp",
    ".x3f"
];
export const INDESIGN_EXTS = [
    ".indd"
];
export const INDEXED_PHOTO_AND_VIDEO_EXTS = [
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".asf",
    ".avi",
    ".bmp",
    ".gif",
    ".jpeg",
    ".jpg",
    ".m4v",
    ".mkv",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".png",
    ".tif",
    ".tiff",
    ".ts",
    ".wbmp",
    ".webm",
    ".webp",
    ".wmv"
];
export const INDEXED_PHOTO_EXTS = [
    ".bmp",
    ".gif",
    ".jpeg",
    ".jpg",
    ".png",
    ".tif",
    ".tiff",
    ".wbmp",
    ".webp"
];
export const INDEXED_VIDEO_EXTS = [
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".asf",
    ".avi",
    ".m4v",
    ".mkv",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".ts",
    ".webm",
    ".wmv"
];
export const IWORK_EXTS = [
    ".key",
    ".kth",
    ".numbers",
    ".pages"
];
export const LIBRE_OFFICE_PDF_PREVIEW_EXTS = [
    ".odp",
    ".odt",
    ".wpd"
];
export const LIBRE_OFFICE_PRESENTATION_EXTS = [
    ".odp"
];
export const LIBRE_OFFICE_WORDPROC_EXTS = [
    ".odt",
    ".wpd"
];
export const LINK_FILE_EXTS = [
    ".url",
    ".webloc",
    ".website"
];
export const LOGGING_ALLOWED_EXTS = [
    ".3dm",
    ".3ds",
    ".3fr",
    ".3g2",
    ".3ga",
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".7z",
    ".aac",
    ".abap",
    ".abr",
    ".abs",
    ".accdb",
    ".accde",
    ".accdr",
    ".accdt",
    ".ace",
    ".ada",
    ".adp",
    ".aep",
    ".ahk",
    ".ai",
    ".aif",
    ".aiff",
    ".als",
    ".amr",
    ".apk",
    ".apkg",
    ".app",
    ".application",
    ".arf",
    ".arj",
    ".arw",
    ".as",
    ".as3",
    ".asc",
    ".ascx",
    ".asf",
    ".asm",
    ".asp",
    ".aspx",
    ".ass",
    ".atn",
    ".attributes",
    ".au",
    ".avi",
    ".avif",
    ".awk",
    ".azw4",
    ".bak",
    ".band",
    ".bas",
    ".bash",
    ".bash_login",
    ".bash_logout",
    ".bash_profile",
    ".bashrc",
    ".bat",
    ".bdoc",
    ".bib",
    ".bimx",
    ".bin",
    ".binder",
    ".blend",
    ".bmp",
    ".brush",
    ".bsh",
    ".bsp",
    ".build",
    ".builder",
    ".bundle",
    ".bup",
    ".bz",
    ".bz2",
    ".c",
    ".c++",
    ".c4d",
    ".cab",
    ".capfile",
    ".capx",
    ".catpart",
    ".cbr",
    ".cc",
    ".cda",
    ".cdr",
    ".cetrainer",
    ".cfc",
    ".cfg",
    ".cfm",
    ".cfml",
    ".chm",
    ".civ5mod",
    ".cl",
    ".class",
    ".clip",
    ".clj",
    ".cls",
    ".cmake",
    ".cmap",
    ".cmd",
    ".coffee",
    ".com",
    ".cpio",
    ".cpl",
    ".cpp",
    ".cpt",
    ".cptx",
    ".cpy",
    ".cr2",
    ".cr3",
    ".crdownload",
    ".crw",
    ".crx",
    ".cs",
    ".cshtml",
    ".cson",
    ".csproj",
    ".css",
    ".csv",
    ".ct",
    ".ctb",
    ".ctp",
    ".curio",
    ".cxx",
    ".d",
    ".dat",
    ".db",
    ".dbf",
    ".dbs",
    ".dcm",
    ".dcr",
    ".dcs",
    ".ddl",
    ".deb",
    ".dem",
    ".dgn",
    ".di",
    ".dif",
    ".diff",
    ".disco",
    ".djvu",
    ".dll",
    ".dmbot",
    ".dmg",
    ".dml",
    ".dng",
    ".do",
    ".doc",
    ".docb",
    ".docm",
    ".docx",
    ".dot",
    ".dotm",
    ".dotx",
    ".dpx",
    ".drv",
    ".ds_store",
    ".dst",
    ".dta",
    ".dtbase",
    ".dtd",
    ".dtml",
    ".dv",
    ".dvi",
    ".dwf",
    ".dwg",
    ".dwl",
    ".dwl2",
    ".dxf",
    ".egg",
    ".ehi",
    ".el",
    ".emakefile",
    ".eml",
    ".enc",
    ".enl",
    ".eps",
    ".epub",
    ".erb",
    ".erf",
    ".erl",
    ".ex4",
    ".exe",
    ".f",
    ".f4v",
    ".f90",
    ".f95",
    ".fbx",
    ".fdr",
    ".fdx",
    ".fig",
    ".filetypedetection",
    ".filter",
    ".fla",
    ".flac",
    ".flipchart",
    ".flp",
    ".flv",
    ".fmf",
    ".fmp12",
    ".form",
    ".framework",
    ".fs",
    ".fsi",
    ".fsscript",
    ".fsx",
    ".fxp",
    ".gadget",
    ".gba",
    ".gdoc",
    ".gemfile",
    ".gemspec",
    ".ggb",
    ".gif",
    ".gitconfig",
    ".gmz",
    ".go",
    ".gp5",
    ".gpx",
    ".graffle",
    ".groovy",
    ".gry",
    ".gsheet",
    ".gslides",
    ".gvy",
    ".gz",
    ".gzip",
    ".h",
    ".h++",
    ".haml",
    ".handlebars",
    ".hbs",
    ".hcp",
    ".heic",
    ".hex",
    ".hh",
    ".hpp",
    ".hrl",
    ".hs",
    ".hta",
    ".htc",
    ".htm",
    ".html",
    ".hwp",
    ".hxx",
    ".ibooks",
    ".ico",
    ".ics",
    ".idl",
    ".idml",
    ".ifc",
    ".ifo",
    ".igs",
    ".iim",
    ".iiq",
    ".img",
    ".inc",
    ".indd",
    ".indt",
    ".inf",
    ".ini",
    ".inl",
    ".ino",
    ".ipa",
    ".ipk",
    ".ipp",
    ".ips",
    ".ipt",
    ".ipynb",
    ".irbrc",
    ".iso",
    ".j2c",
    ".j2k",
    ".jade",
    ".jar",
    ".jav",
    ".java",
    ".jp2",
    ".jpc",
    ".jpeg",
    ".jpf",
    ".jpg",
    ".jpg2",
    ".jpm",
    ".jpx",
    ".js",
    ".jse",
    ".json",
    ".jsp",
    ".jsx",
    ".jww",
    ".kdb",
    ".kdbx",
    ".kdc",
    ".kext",
    ".key",
    ".keynote",
    ".kfn",
    ".kml",
    ".kmz",
    ".kth",
    ".l",
    ".less",
    ".lha",
    ".lhs",
    ".lib4d",
    ".lisp",
    ".lnk",
    ".log",
    ".lrcat",
    ".lrec",
    ".lrtemplate",
    ".lst",
    ".ltx",
    ".lua",
    ".lz",
    ".lzh",
    ".lzma",
    ".m",
    ".m2t",
    ".m2ts",
    ".m3u",
    ".m3u8",
    ".m4a",
    ".m4r",
    ".m4v",
    ".ma",
    ".maff",
    ".make",
    ".mapset",
    ".markdn",
    ".markdown",
    ".mat",
    ".max",
    ".mb",
    ".mcmeta",
    ".mcworld",
    ".md",
    ".md5",
    ".mdb",
    ".mdown",
    ".mef",
    ".mht",
    ".mid",
    ".mjdoc",
    ".mkdn",
    ".mkv",
    ".ml",
    ".mli",
    ".mll",
    ".mly",
    ".mm",
    ".mmap",
    ".mobi",
    ".mod",
    ".mos",
    ".mov",
    ".mp3",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mpkg",
    ".mpp",
    ".mq4",
    ".mrw",
    ".msc",
    ".mscz",
    ".msg",
    ".msh",
    ".msh1",
    ".msh1xml",
    ".msh2",
    ".msh2xml",
    ".mshxml",
    ".msi",
    ".msm",
    ".msp",
    ".mst",
    ".mts",
    ".mtw",
    ".mud",
    ".mus",
    ".musx",
    ".mxf",
    ".mxm",
    ".myo",
    ".nb",
    ".nef",
    ".nfo",
    ".notebook",
    ".nrw",
    ".numbers",
    ".nwd",
    ".obj",
    ".odg",
    ".odp",
    ".ods",
    ".odt",
    ".oga",
    ".ogg",
    ".oggtheora",
    ".ogv",
    ".ogx",
    ".omf",
    ".omniplan",
    ".one",
    ".onetoc2",
    ".oo3",
    ".opj",
    ".opml",
    ".opus",
    ".orf",
    ".org",
    ".osascript",
    ".osk",
    ".osm",
    ".osz",
    ".otf",
    ".out",
    ".ova",
    ".p",
    ".p7m",
    ".package",
    ".pages",
    ".paper",
    ".papert",
    ".part",
    ".partial",
    ".pas",
    ".patch",
    ".pbo",
    ".pcm",
    ".pde",
    ".pdf",
    ".pdo",
    ".pef",
    ".pes",
    ".pfx",
    ".php",
    ".php2",
    ".php3",
    ".php4",
    ".php5",
    ".phtml",
    ".pif",
    ".pk3",
    ".pka",
    ".pkg",
    ".pkt",
    ".pl",
    ".plist",
    ".pln",
    ".plugin",
    ".pm",
    ".png",
    ".pod",
    ".pot",
    ".potm",
    ".potx",
    ".pp",
    ".ppam",
    ".ppm",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".prc",
    ".prj",
    ".prn",
    ".pro",
    ".profile",
    ".properties",
    ".prproj",
    ".prt",
    ".ps",
    ".ps1",
    ".ps1xml",
    ".ps2",
    ".ps2xml",
    ".psarc",
    ".psb",
    ".psc",
    ".psc1",
    ".psc2",
    ".psd",
    ".psd1",
    ".psm1",
    ".pst",
    ".pt",
    ".ptm",
    ".ptp",
    ".ptx",
    ".pub",
    ".py",
    ".pyw",
    ".pzf",
    ".pzfx",
    ".qbb",
    ".qbm",
    ".qbw",
    ".qbx",
    ".qdfm",
    ".qpkg",
    ".qtz",
    ".r",
    ".r3d",
    ".raf",
    ".rake",
    ".rar",
    ".razersynapse",
    ".rb",
    ".rbx",
    ".rbz",
    ".rc",
    ".rdata",
    ".rdp",
    ".re",
    ".readme",
    ".reg",
    ".rest",
    ".result",
    ".resw",
    ".resx",
    ".rfa",
    ".rhtml",
    ".rjs",
    ".rm",
    ".rmvb",
    ".rpm",
    ".rprofile",
    ".rpy",
    ".rs",
    ".rss",
    ".rst",
    ".rte",
    ".rtf",
    ".rtfd",
    ".run",
    ".rvt",
    ".rw2",
    ".rwl",
    ".rwsw",
    ".rwtheme",
    ".rxml",
    ".s",
    ".sas",
    ".sass",
    ".sav",
    ".sb2",
    ".scala",
    ".scf",
    ".schematic",
    ".scm",
    ".sconscript",
    ".sconstruct",
    ".scr",
    ".script",
    ".scriv",
    ".scs",
    ".scss",
    ".sfx",
    ".sgml",
    ".sh",
    ".shp",
    ".shtml",
    ".shx",
    ".sib",
    ".sims3pack",
    ".sit",
    ".sitx",
    ".skb",
    ".sketch",
    ".skp",
    ".sldasm",
    ".slddrw",
    ".sldm",
    ".sldprt",
    ".sldx",
    ".slx",
    ".smi",
    ".sml",
    ".sookasa",
    ".space",
    ".sps",
    ".spv",
    ".sql",
    ".sr2",
    ".src",
    ".srt",
    ".step",
    ".stl",
    ".story",
    ".stp",
    ".studio",
    ".studio3",
    ".sty",
    ".svg",
    ".svgz",
    ".swf",
    ".swift",
    ".tac",
    ".tar",
    ".taz",
    ".tbz",
    ".tbz2",
    ".tcl",
    ".tex",
    ".text",
    ".textclipping",
    ".textile",
    ".tga",
    ".tgz",
    ".thm",
    ".tif",
    ".tiff",
    ".tld",
    ".tli",
    ".tlz",
    ".tmod",
    ".tmp",
    ".tmpl",
    ".torrent",
    ".tpl",
    ".ts",
    ".tst",
    ".tsx",
    ".ttf",
    ".twbx",
    ".txt",
    ".txz",
    ".tz",
    ".ufo",
    ".unitypackage",
    ".ups",
    ".url",
    ".utf8",
    ".uue",
    ".vb",
    ".vbe",
    ".vbs",
    ".vcf",
    ".vdx",
    ".vi",
    ".vim",
    ".vob",
    ".vpdoc",
    ".vsd",
    ".vsdx",
    ".vtt",
    ".vwx",
    ".vxd",
    ".wad",
    ".war",
    ".watch",
    ".wav",
    ".wbk",
    ".wbmp",
    ".web",
    ".webarchive",
    ".webloc",
    ".webm",
    ".webp",
    ".website",
    ".wire",
    ".wlmp",
    ".wma",
    ".wmv",
    ".world",
    ".wpd",
    ".wps",
    ".ws",
    ".wsc",
    ".wsdl",
    ".wsf",
    ".wsh",
    ".wxy",
    ".x3f",
    ".x_t",
    ".xar",
    ".xcf",
    ".xcodeproj",
    ".xd",
    ".xhtml",
    ".xla",
    ".xlam",
    ".xll",
    ".xlm",
    ".xls",
    ".xlsb",
    ".xlsm",
    ".xlsx",
    ".xlt",
    ".xltm",
    ".xltx",
    ".xlw",
    ".xmind",
    ".xml",
    ".xmp",
    ".xnb",
    ".xoml",
    ".xps",
    ".xsd",
    ".xsl",
    ".xslt",
    ".xz",
    ".yaml",
    ".yaws",
    ".ydk",
    ".yml",
    ".z",
    ".z2f",
    ".zip",
    ".zipx",
    ".zsh"
];
export const LOGGING_UNALLOWED_EXT_PLACEHOLDER = "OTHER";
export const MARKDOWN_EXTS = [
    ".markdown",
    ".md",
    ".mdown",
    ".mkdn"
];
export const MEDIA_TRANSCODE_EXTS = [
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".aac",
    ".aif",
    ".aiff",
    ".asf",
    ".avi",
    ".dv",
    ".flac",
    ".flv",
    ".m2t",
    ".m2ts",
    ".m4a",
    ".m4r",
    ".m4v",
    ".mkv",
    ".mov",
    ".mp3",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mts",
    ".mxf",
    ".oga",
    ".ogg",
    ".oggtheora",
    ".ogv",
    ".rm",
    ".ts",
    ".vob",
    ".wav",
    ".webm",
    ".wma",
    ".wmv"
];
export const MSOFFICE_DOC_EXTS = [
    ".csv",
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".ods",
    ".pdf",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".xlt",
    ".xltx"
];
export const MSOFFICE_EDITOR_FILE_EXTS = [
    ".csv",
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".ods",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".xlt",
    ".xltx"
];
export const MSOFFICE_EXCEL_EXTS = [
    ".csv",
    ".ods",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".xlt",
    ".xltx"
];
export const MSOFFICE_NONEXCEL_EXTS = [
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf"
];
export const MSOFFICE_PDF_PREVIEW_EXTS = [
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".pdf",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".rtf"
];
export const MSOFFICE_PRESENTATION_EXTS = [
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx"
];
export const MSOFFICE_WORDPROC_EXTS = [
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".rtf"
];
export const NON_GENERATED_HTML_EXTS = [
    ".htm",
    ".html"
];
export const PACKAGE_EXTS = [
    ".app",
    ".band",
    ".bundle",
    ".curio",
    ".dtbase",
    ".framework",
    ".graffle",
    ".kext",
    ".key",
    ".keynote",
    ".mapset",
    ".mjdoc",
    ".mpkg",
    ".numbers",
    ".omniplan",
    ".oo3",
    ".pages",
    ".pkg",
    ".plugin",
    ".qdfm",
    ".rtfd",
    ".rwsw",
    ".rwtheme",
    ".scriv",
    ".sketch",
    ".ufo",
    ".vpdoc",
    ".xcodeproj",
    ".xd"
];
export const PAPER_CLOUD_DOC_ALL_EXTS = [
    ".binder",
    ".paper",
    ".papert"
];
export const PAPER_CLOUD_DOC_BINDER_EXTS = [
    ".binder"
];
export const PAPER_CLOUD_DOC_NON_BINDER_EXTS = [
    ".paper",
    ".papert"
];
export const PDF_EXTS = [
    ".pdf"
];
export const PHOTO_EXTS = [
    ".3fr",
    ".arw",
    ".avif",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".erf",
    ".gif",
    ".heic",
    ".j2c",
    ".j2k",
    ".jp2",
    ".jpc",
    ".jpeg",
    ".jpf",
    ".jpg",
    ".jpg2",
    ".jpm",
    ".jpx",
    ".kdc",
    ".mef",
    ".mos",
    ".mrw",
    ".nef",
    ".nrw",
    ".orf",
    ".pef",
    ".png",
    ".ppm",
    ".r3d",
    ".raf",
    ".rw2",
    ".rwl",
    ".sr2",
    ".tga",
    ".tif",
    ".tiff",
    ".wbmp",
    ".web",
    ".webp",
    ".x3f"
];
export const PLAINTEXT_EXTS = [
    ".adp",
    ".asc",
    ".asp",
    ".bash_login",
    ".bash_logout",
    ".bash_profile",
    ".bashrc",
    ".bsh",
    ".builder",
    ".c++",
    ".capfile",
    ".cpt",
    ".cshtml",
    ".cson",
    ".csproj",
    ".csv",
    ".ctp",
    ".ddl",
    ".dif",
    ".disco",
    ".dml",
    ".dtml",
    ".emakefile",
    ".f90",
    ".f95",
    ".fsscript",
    ".fsx",
    ".gitconfig",
    ".gvy",
    ".h++",
    ".hcp",
    ".htc",
    ".iim",
    ".inl",
    ".ipp",
    ".irbrc",
    ".jav",
    ".l",
    ".log",
    ".ltx",
    ".markdn",
    ".mud",
    ".nfo",
    ".opml",
    ".org",
    ".osascript",
    ".php2",
    ".php3",
    ".php4",
    ".php5",
    ".pod",
    ".profile",
    ".ps1",
    ".psd1",
    ".psm1",
    ".pt",
    ".rc",
    ".re",
    ".readme",
    ".resw",
    ".resx",
    ".rjs",
    ".rpy",
    ".rxml",
    ".sgml",
    ".shtml",
    ".sty",
    ".tcl",
    ".text",
    ".textile",
    ".tld",
    ".tli",
    ".txt",
    ".xoml",
    ".yaws"
];
export const POINTER_CLOUD_DOC_EXTS = [
    ".web"
];
export const PRESENTATION_EXTS = [
    ".odp",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx"
];
export const RAW_FILE_FOR_PREVIEW_EXTS = [
    ".gif",
    ".svg"
];
export const ROOT_PHOTO_AND_VIDEO_CU_EXTS = [
    ".3fr",
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".arw",
    ".asf",
    ".avi",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".dv",
    ".erf",
    ".flv",
    ".gif",
    ".heic",
    ".jpeg",
    ".jpg",
    ".kdc",
    ".m2t",
    ".m4v",
    ".mef",
    ".mkv",
    ".mos",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mrw",
    ".mts",
    ".nef",
    ".nrw",
    ".orf",
    ".pef",
    ".png",
    ".r3d",
    ".raf",
    ".rw2",
    ".rwl",
    ".sr2",
    ".tif",
    ".tiff",
    ".ts",
    ".vob",
    ".wbmp",
    ".webm",
    ".webp",
    ".wmv",
    ".x3f"
];
export const ROOT_PHOTO_AND_VIDEO_EXTS = [
    ".3fr",
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".arw",
    ".asf",
    ".avi",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".dv",
    ".erf",
    ".flv",
    ".gif",
    ".heic",
    ".jpeg",
    ".jpg",
    ".kdc",
    ".m2t",
    ".m4v",
    ".mef",
    ".mkv",
    ".mos",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mrw",
    ".mts",
    ".nef",
    ".nrw",
    ".orf",
    ".pef",
    ".png",
    ".r3d",
    ".raf",
    ".rw2",
    ".rwl",
    ".sr2",
    ".tif",
    ".tiff",
    ".ts",
    ".vob",
    ".wbmp",
    ".webm",
    ".webp",
    ".wmv",
    ".x3f"
];
export const ROOT_PHOTO_AND_VIDEO_NON_CU_EXTS = [
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".asf",
    ".avi",
    ".dv",
    ".flv",
    ".heic",
    ".jpeg",
    ".jpg",
    ".m2t",
    ".m4v",
    ".mkv",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mts",
    ".tif",
    ".tiff",
    ".ts",
    ".vob",
    ".webm",
    ".wmv"
];
export const ROOT_PHOTO_CU_EXTS = [
    ".3fr",
    ".arw",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".erf",
    ".gif",
    ".heic",
    ".jpeg",
    ".jpg",
    ".kdc",
    ".mef",
    ".mos",
    ".mrw",
    ".nef",
    ".nrw",
    ".orf",
    ".pef",
    ".png",
    ".r3d",
    ".raf",
    ".rw2",
    ".rwl",
    ".sr2",
    ".tif",
    ".tiff",
    ".wbmp",
    ".webp",
    ".x3f"
];
export const ROOT_PHOTO_EXTS = [
    ".3fr",
    ".arw",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".erf",
    ".gif",
    ".heic",
    ".jpeg",
    ".jpg",
    ".kdc",
    ".mef",
    ".mos",
    ".mrw",
    ".nef",
    ".nrw",
    ".orf",
    ".pef",
    ".png",
    ".r3d",
    ".raf",
    ".rw2",
    ".rwl",
    ".sr2",
    ".tif",
    ".tiff",
    ".wbmp",
    ".webp",
    ".x3f"
];
export const ROOT_PHOTO_NON_CU_EXTS = [
    ".heic",
    ".jpeg",
    ".jpg",
    ".tif",
    ".tiff"
];
export const ROOT_VIDEO_EXTS = [
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".asf",
    ".avi",
    ".dv",
    ".flv",
    ".m2t",
    ".m4v",
    ".mkv",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mts",
    ".ts",
    ".vob",
    ".webm",
    ".wmv"
];
export const SCANNABLE_EXTS = [
    ".jpeg",
    ".jpg",
    ".tif",
    ".tiff"
];
export const SCRUBBING_DOC_EXTS = [
    ".doc",
    ".docx",
    ".dotx",
    ".pdf",
    ".ppt",
    ".pptx"
];
export const THREE_EXTS = [
    ".obj"
];
export const THUMBNAIL_EXTS = [
    ".3fr",
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".ai",
    ".arw",
    ".asf",
    ".avi",
    ".avif",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".dv",
    ".eps",
    ".erf",
    ".flv",
    ".gif",
    ".heic",
    ".indd",
    ".j2c",
    ".j2k",
    ".jp2",
    ".jpc",
    ".jpeg",
    ".jpf",
    ".jpg",
    ".jpg2",
    ".jpm",
    ".jpx",
    ".kdc",
    ".m2t",
    ".m2ts",
    ".m4v",
    ".mef",
    ".mkv",
    ".mos",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mrw",
    ".mts",
    ".mxf",
    ".nef",
    ".nrw",
    ".oggtheora",
    ".ogv",
    ".orf",
    ".otf",
    ".pef",
    ".png",
    ".ppm",
    ".psd",
    ".r3d",
    ".raf",
    ".rm",
    ".rw2",
    ".rwl",
    ".sr2",
    ".svg",
    ".svgz",
    ".tga",
    ".tif",
    ".tiff",
    ".ts",
    ".ttf",
    ".vob",
    ".wbmp",
    ".web",
    ".webm",
    ".webp",
    ".wmv",
    ".x3f"
];
export const THUMBNAIL_IMAGE_EXTS = [
    ".3fr",
    ".ai",
    ".arw",
    ".avif",
    ".bmp",
    ".cr2",
    ".cr3",
    ".crw",
    ".dcr",
    ".dcs",
    ".dng",
    ".eps",
    ".erf",
    ".gif",
    ".heic",
    ".indd",
    ".j2c",
    ".j2k",
    ".jp2",
    ".jpc",
    ".jpeg",
    ".jpf",
    ".jpg",
    ".jpg2",
    ".jpm",
    ".jpx",
    ".kdc",
    ".mef",
    ".mos",
    ".mrw",
    ".nef",
    ".nrw",
    ".orf",
    ".otf",
    ".pef",
    ".png",
    ".ppm",
    ".psd",
    ".r3d",
    ".raf",
    ".rw2",
    ".rwl",
    ".sr2",
    ".svg",
    ".svgz",
    ".tga",
    ".tif",
    ".tiff",
    ".ttf",
    ".wbmp",
    ".web",
    ".webp",
    ".x3f"
];
export const TRANSCODE_IWORK_EXTS = [
    ".key",
    ".keynote"
];
export const TRANSCODE_VIDEO_EXTS = [
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".asf",
    ".avi",
    ".dv",
    ".flv",
    ".m2t",
    ".m2ts",
    ".m4v",
    ".mkv",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mts",
    ".mxf",
    ".oggtheora",
    ".ogv",
    ".rm",
    ".ts",
    ".vob",
    ".webm",
    ".wmv"
];
export const URL_FILE_EXTS = [
    ".url",
    ".website"
];
export const WATERMARKING_EXTENSIONS = [
    ".bmp",
    ".jpeg",
    ".jpg",
    ".pdf",
    ".png"
];
export const WEBLOC_FILE_EXTS = [
    ".webloc"
];
export const WEB_SHORTCUT_EXTS = [
    ".web"
];
export const WORDPROC_EXTS = [
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".odt",
    ".rtf",
    ".wpd"
];
//# sourceMappingURL=extension_constants.preenvesnextjs.map
